"use strict";
import React from "react";
export function If(props) {
  if (props.condition) {
    return props.children;
  }
  return /* @__PURE__ */ React.createElement("div", null);
}
